import { ReviewSourceTypes } from "../../types/index.ts";
import { convertSnakeToTitleCase } from "../../utils/snake-to-capital.ts";
import AgentNumberedTextfieldsListWithSource from "./AgentNumberedTextfieldsListWithSource.tsx";
import InlineSources from "./InlineSources.tsx";

export interface Props {
  fields: {
    title: string;
    value: any;
  };
  showHorizontal?: boolean;
  onSourceClick: (selectedSource: ReviewSourceTypes) => void;
  setListOfSourcesForSelectedSources: (
    selectedSource: ReviewSourceTypes[]
  ) => void;
  expandedView?: boolean;
  isDisabled?: boolean;
  handleChange: any
}

const CombinedAgentEditFieldWithTextListAndSource = ({
  fields,
  showHorizontal,
  onSourceClick,
  expandedView,
  isDisabled,
  setListOfSourcesForSelectedSources,
  handleChange,
}: Props) => {

  return (
    <div
      className={`relative border-1 border-[#E4E4E7] rounded-md overflow-hidden flex items-stretch bg-white w-full ${showHorizontal ? "flex-row" : "flex-col"
        } group-hover:border-zinc-400 py-2`}
    >
      <AgentNumberedTextfieldsListWithSource
        fieldValueObjArray={(fields?.value?.value ?? [] )as string[]}
        placeholder={`Add ${convertSnakeToTitleCase(fields.title)}`}
        onChange={handleChange}
        noBorder={true}
        expandedView={expandedView}
        isDisabled={isDisabled}
      />

      {fields?.value?.sources && (
        <div className={"px-4 pt-4"}>
          <InlineSources
            sources={fields?.value?.sources}
            onSourceClick={onSourceClick}
            setListOfSourcesForSelectedSources={
              setListOfSourcesForSelectedSources
            }
            tooltipPlacement={expandedView ? "bottom" : "bottom"}
          />
        </div>
      )}
    </div>
  );
};

export default CombinedAgentEditFieldWithTextListAndSource;